var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29,17.39,17.33,5.72a5,5,0,0,0-1.66-1.06,5.05,5.05,0,0,0-1.92-.43H7A2.12,2.12,0,0,0,4.86,6.32v6.8A5,5,0,0,0,5.29,15a4.9,4.9,0,0,0,1.06,1.66L18,28.39a2,2,0,0,0,1.47.6,2.09,2.09,0,0,0,1.48-.6l8-8a2,2,0,0,0,.61-1.47A2.1,2.1,0,0,0,29,17.39ZM11.57,10.94a2.1,2.1,0,0,1-3,0,2.1,2.1,0,0,1,0-3,2.1,2.1,0,0,1,3,0,2.1,2.1,0,0,1,0,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.231d3855.svg";
export { ForwardRef as ReactComponent };